<template>

    <div v-if="message" class="alert alert-danger" role="alert">
        {{message}}
    </div>
    
</template>

<script>
    export default {
      name: 'ErrorMessage',
      data() {
        return {}
      },
      methods: {},
      props: ['message'],
    }
</script>


// WEBPACK FOOTER //
// src/components/ErrorMessage.vue